export default {
  namespaced: true,

  state: {
    contact: {
      salutation: null,
      firstname: null,
      lastname: null,
      street: null,
      number: null,
      zip: null,
      city: null,
      phone: null,
      email: null,
      customFields: {
        dataPrivacy: false,
        acceptContact: false,
        newsletter: false
      }
    },
    requiredFields: [
      "firstname",
      "lastname",
      "email"
    ],
    savedSearchList: null,
    exposeInquiryList: null
  },

  getters: {
    disclaimerAccepted: state => {
      if (!state.contact.customFields) {
        return false;
      }

      if ("acceptContact" in state.contact.customFields && "dataPrivacy" in state.contact.customFields) {
        return state.contact.customFields.acceptContact && state.contact.customFields.dataPrivacy;
      }

      return false;
    }
  },

  mutations: {
    contact(state, contact) {
      state.contact = contact;
    },

    savedSearchList(state, savedSearchList) {
      state.savedSearchList = savedSearchList;
    },

    exposeInquiryList(state, exposeInquiryList) {
      state.exposeInquiryList = exposeInquiryList;
    }
  },

  actions: {
    load({ commit, dispatch }) {
      return dispatch("ajax", {
          method: "get",
          url: "/v1/contact"
      }, { root: true }).then((res) => {
          commit("contact", res);
          return res;
      });
    },

    save({ commit, dispatch }, contact) {
      return dispatch("ajax", {
        method: "put",
        url: "/v1/contact",
        data: contact
      }, { root: true }).then((res) => {
        commit("contact", res);
        return res;
      });
    },

    loadSavedSearchList({ commit, dispatch, state }) {
      if (state.savedSearchList == null) {
        return dispatch("ajax", {
          url: "/v1/saved-search",
          method: "get"
        }, { root: true }).then(res => {
          commit("savedSearchList", res);
        });
      }
    },

    saveSavedSearch({ commit, dispatch }, savedSearch) {
      return dispatch("ajax", {
        url: "/v1/saved-search/" + savedSearch.uuid,
        method: "put",
        data: savedSearch
      }, { root: true }).then(res => {
        commit("savedSearchList", null);
        dispatch("loadSavedSearchList");
      });
    },

    deleteSavedSearch({ commit, dispatch }, savedSearch) {
      return dispatch("ajax", {
        url: "/v1/saved-search/" + savedSearch.uuid,
        method: "delete"
      }, { root: true }).then(res => {
        commit("savedSearchList", null);
        dispatch("loadSavedSearchList");
      });
    },

    createSavedSearch({ commit, dispatch }, savedSearch) {
      return dispatch("ajax", {
        url: "/v1/saved-search",
        method: "post",
        data: savedSearch
      }, { root: true }).then(res => {
        commit("savedSearchList", null);
        dispatch("loadSavedSearchList");
      });
    },

    loadExposeInquiryList({ commit, dispatch, state }) {
      if (state.exposeInquiryList == null) {
        return dispatch("ajax", {
          url: "/v1/expose-inquiry",
          method: "get"
        }, { root: true }).then(res => {
          commit("exposeInquiryList", res);
        });
      }
    }
  }
};
